import { NgModule } from '@angular/core';
import {
  VizBreadcrumbModule,
  VizContainerModule,
  VizDrawerModule,
  VizFeedbackIndicatorModule,
  VizFileUploadModule,
  VizFooterModule,
  VizHeaderModule,
  VizHttpStatusModule,
  //VizLoginModule,
  //VizLoginOktaModule,
  VizNodataModule,
  //VizSidenavModule,
  //VizSteppersModule,
  //VizTableModule
} from 'vizient-toolkit';
import { CommonModule } from '@angular/common';

const vizList = [
  VizBreadcrumbModule,
  VizContainerModule,
  VizDrawerModule,
  VizFeedbackIndicatorModule,
  VizFileUploadModule,
  VizFooterModule,
  VizHeaderModule,
  VizHttpStatusModule,
  // VizLoginModule,
  // VizLoginOktaModule,
  VizNodataModule,
  // VizSidenavModule,
  // VizSteppersModule,
  // VizTableModule
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ...vizList
  ],
  exports: [
    ...vizList
  ]
})
export class AppToolkitModule { }
